import React, { useState, useEffect } from "react";
import { FiArrowUp } from "react-icons/fi";
import "./Up.css";

const SCROLL_THRESHOLD = 300;

const Up = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > SCROLL_THRESHOLD);
    };

    onScroll(); // estado correto caso a página abra já rolada
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({
      top: 0,
      behavior: prefersReduced ? "auto" : "smooth",
    });
  };

  return (
    <button
      type="button"
      className={`up-button ${isVisible ? "up-button--visible" : ""}`}
      onClick={scrollToTop}
      aria-label="Voltar ao topo"
    >
      <FiArrowUp />
    </button>
  );
};

export default Up;